/**
 * D3.jsグラフ初期化の司令塔 (src/js/chart-initializer.ts)
 *
 * このファイルは、各グラフの初期化スクリプト（イニシャライザ）をインポートし、
 * 全てのグラフに共通の機能（例: ウィンドウリサイズ時の再描画処理）を提供します。
 */

// -----------------------------------------------------------------------------
// 1. 各種モジュールのインポート
// -----------------------------------------------------------------------------

// 各グラフのイニシャライザ
// イニシャライザはインポートされるだけで、DOMのロードを監視し、
// 対応するHTML要素を見つけてグラフクラスをインスタンス化します。

import '../charts/weight-chart/initializer.js';
import '../charts/pfc-pie-chart/initializer.js';
import '../charts/monthly-steps-chart/initializer.js';
import '../charts/sleep-cycle-chart/initializer.js';
import '../charts/game-console-chart/initializer.js';
import '../charts/console-wars-chart/initializer.js';
import '../charts/bar-chart-race/initializer.js';
import '../charts/console-sales-timeline/initializer.js';
import '../charts/console-sales-origin/initializer.js';
import '../charts/bcr-v2/initializer.ts';


// -----------------------------------------------------------------------------
// 2. 全グラフ共通のリサイズ処理
// -----------------------------------------------------------------------------

/**
 * すべてのグラフインスタンスが共通で持つべきメソッドを定義するインターフェース
 */
interface ResizableChart {
	redrawOnResize: () => void;
}

/**
 * カスタムプロパティ `_chartInstance` を持つDOM要素の型定義
 */
type ElementWithChartInstance = Element & { _chartInstance?: ResizableChart };


// 即時実行関数でスコープを分離し、グローバル汚染を防ぐ
{
	const chartInstances: ResizableChart[] = [];
	let resizeTimeout: number;

	// DOMの準備完了後、ページ内の全グラフインスタンスを収集する
	document.addEventListener('DOMContentLoaded', () => {
		const chartElements = document.querySelectorAll('[data-chart-instance]');
		
		chartElements.forEach((el: Element) => {
			const chartEl = el as ElementWithChartInstance;

			// 各イニシャライザによってDOM要素に直接格納されたインスタンスを取得
			if (chartEl._chartInstance) {
				chartInstances.push(chartEl._chartInstance);
			}
		});
	});

	/**
	 * ウィンドウリサイズ時に、収集した全てのグラフの再描画メソッドを呼び出す。
	 * パフォーマンスのため、リサイズイベントの発生を250ms遅延させる（デバウンス）。
	 */
	const handleResize = () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = window.setTimeout(() => {
			chartInstances.forEach(instance => {
				if (typeof instance.redrawOnResize === 'function') {
					instance.redrawOnResize();
				}
			});
		}, 250);
	};

	window.addEventListener('resize', handleResize);
}